const IconReactJs = () => (
    <svg height='160' viewBox="-11.5 -10.23174 23 20.46348">
        <circle cx="0" cy="0" r="2.05" className="fill-sky-400 dark:fill-[#61dafb]"/>
        <g className='stroke-sky-400 dark:stroke-[#61dafb]' strokeWidth="1" fill="none">
            <ellipse rx="11" ry="4.2"/>
            <ellipse rx="11" ry="4.2" transform="rotate(60)"/>
            <ellipse rx="11" ry="4.2" transform="rotate(120)"/>
        </g>
    </svg>
);

export default IconReactJs;
